import { Component } from "react";
import "./../common.css";
import ElementWithIcons from "./../formElements/ElementWithIcons";
import arrowImg from "./../../images/down-arrow.svg";
import greyArrowImg from "./../../images/down-arrow-grey.svg";

export default class Dropdown extends Component {
  render() {
    const props = {
      type: "select",
      name: this.props.name,
      id: this.props.id,
      onChange: this.props.onChange,
      value: this.props.value,
      className: "app-select" + (this.props.className ? " " + this.props.className : ""),
      leftImage: this.props.leftImage,
      rightImage: arrowImg,
    };

    if (this.props.disabled) {
      props.disabled = true;
      props.rightImage = greyArrowImg;
    }

    if (this.props.width) {
      props.width = this.props.width;
    }
    if (this.props.backgroundSize) {
      props.backgroundSize = this.props.backgroundSize;
    }

    return <ElementWithIcons {...props}>{this.props.children}</ElementWithIcons>;
  }
}
